// Oak's font stacks; embedded previews can't redefine any family named here.
export const OAK_FONT_FAMILY = '"Roboto", "Helvetica", "Arial", sans-serif';
export const OAK_MONOSPACE_FONT_FAMILY =
  "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace";
